export enum SocialLinkType {
  Email = "email",
  Facebook = "facebook",
  Instagram = "instagram",
  Twitter = "twitter",
}
